export const environment = {
    production: false,
    panel: "radheexch_",
    // domain: "jarvisexch.com",
    // baseUrl: "https://jarvisexch.com",
    domain: "radhexchange.com",
    baseUrl: "https://api.radhexchange.com",
    // domain: "parker777.com",
    // baseUrl: "https://api.parker777.com",
    pollers: {
        oddsData: 600,
        listOddsData: 10000,
        scoresData: 1000,
    },
    isMobile: true,
    demoLoginUserName: 'demo123',
    wpLinkShowPages: '/home, /dashboard, /inplay, /sports, /casino',
    demoDWLink: '',
    trafficTag: '',
    noDataMsg: 'No Data Found',
    imgPrefix: '/radheexch_client',
    guestEnable: false,
    darkMode: false,
    horseRaceJockeyImgPrefix: 'https://content-cache.cdnbf.net/feeds_images/Horses/SilkColours/',
    stakes: { "stake_name_1": "100", "stake_name_2": "5000", "stake_name_3": "500", "stake_name_4": "25000", "stake_name_5": "50000", "stake_name_6": "100000", "stake_name_7": "500000", "stake_name_8": "1000000", "stake_amount_1": 100, "stake_amount_2": 5000, "stake_amount_3": 500, "stake_amount_4": 25000, "stake_amount_5": 50000, "stake_amount_6": 100000, "stake_amount_7": 500000, "stake_amount_8": 1000000 },
    host: {
        domain: '',
        apiDomain: '',
        name: '',
        dName: '',
        ext: '',
        theme: '',
        email: '',
        pusher: {
            key: '',
            cluster: ''
        },
        social: {
            isShow: false,
            whatsapp:'',
            facebook: '',
            instagram: '',
            telegram: '',
        },
        demoLoginWpLink: '',
        themePath: [''],
        guestEnable: false,
        ftLivetvData: 'https://e765432.xyz/static/cc6c487c44b971286c3d0d1e24649619b4681674/getdata.php?chid=',
        afLoginRedirectUrl: '',
        afterLoginNoticePath: '',
        newHomePage: false,
        isCustomBanner: false,
        demoLogin: false,
        depoWithdraw: false,
        downloadApk: '',
        iframeDomainUrl: '',
        signUpActive: false,
        tawkToSrc: '',
        footer: {
            isShow: true,
        },
        desktopBannerList: ['https://sthiracdn.com/assets/radheexch-client/banner/main-banner2.webp', 'https://sthiracdn.com/assets/radheexch-client/banner/main-banner3.webp', 'https://sthiracdn.com/assets/radheexch-client/banner/main-banner4.webp', 'https://sthiracdn.com/assets/radheexch-client/banner/main-banner5.webp'],
        mobileBannerList: ['https://sthiracdn.com/assets/radheexch-client/banner/main-banner2.webp', 'https://sthiracdn.com/assets/radheexch-client/banner/main-banner3.webp', 'https://sthiracdn.com/assets/radheexch-client/banner/main-banner4.webp', 'https://sthiracdn.com/assets/radheexch-client/banner/main-banner5.webp']
    },
    hosts: [
        {
            domain: 'localhost',
            apiDomain: 'localhost',
            name: 'localhost',
            dName: 'LocalHost',
            ext: '.com',
            theme: 'blue-body',
            email: '',
            pusher: {
                key: 'c8bbdb36496c73b41567',
                cluster: 'eu'
            },
            social: {
                isShow: false,
                whatsapp:'',
                facebook: '',
                instagram: '',
                telegram: '',
            },
            demoLoginWpLink: '',
            themePath: ['assets/css/theme-files/theme-master.css'],
            guestEnable: true,
            ftLivetvData: 'https://e765432.xyz/static/cc6c487c44b971286c3d0d1e24649619b4681674/getdata.php?chid=',
            afLoginRedirectUrl: '/dashboard',
            afterLoginNoticePath: '',
            newHomePage: false,
            isCustomBanner: false,
            demoLogin: true,
            depoWithdraw: false,
            downloadApk: '',
            iframeDomainUrl: '',
            signUpActive: false,
            tawkToSrc: '',
            footer: {
                isShow: true,
            },
            desktopBannerList: ['https://sthiracdn.com/assets/radheexch-client/banner/main-banner2.webp', 'https://sthiracdn.com/assets/radheexch-client/banner/main-banner3.webp', 'https://sthiracdn.com/assets/radheexch-client/banner/main-banner4.webp', 'https://sthiracdn.com/assets/radheexch-client/banner/main-banner5.webp'],
            mobileBannerList: ['https://sthiracdn.com/assets/radheexch-client/banner/main-banner2.webp', 'https://sthiracdn.com/assets/radheexch-client/banner/main-banner3.webp', 'https://sthiracdn.com/assets/radheexch-client/banner/main-banner4.webp', 'https://sthiracdn.com/assets/radheexch-client/banner/main-banner5.webp']
        },
        {
            domain: 'radhexchange.com',
            apiDomain: 'radhexchange.com',
            name: 'radhexchange',
            dName: 'radhexchange',
            ext: '.com',
            theme: 'blue-body',
            email: '',
            pusher: {
                key: '76d7c55c2b5f8747ffd4',
                cluster: 'eu'
            },
            social: {
                isShow: false,
                whatsapp:'',
                facebook: '',
                instagram: '',
                telegram: '',
            },
            demoLoginWpLink: '',
            themePath: ['assets/css/theme-files/theme-master.css'],
            guestEnable: true,
            ftLivetvData: 'https://getscoredata.com/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
            afLoginRedirectUrl: '/dashboard',
            afterLoginNoticePath: '',
            newHomePage: false,
            isCustomBanner: false,
            demoLogin: true,
            depoWithdraw: false,
            downloadApk: './assets/img/RadhaExchange.apk',
            iframeDomainUrl: '',
            signUpActive: false,
            tawkToSrc: '',
            footer: {
                isShow: true,
            },
            desktopBannerList: ['https://sthiracdn.com/assets/radheexch-client/banner/main-banner2.webp', 'https://sthiracdn.com/assets/radheexch-client/banner/main-banner3.webp', 'https://sthiracdn.com/assets/radheexch-client/banner/main-banner4.webp', 'https://sthiracdn.com/assets/radheexch-client/banner/main-banner5.webp'],
            mobileBannerList: ['https://sthiracdn.com/assets/radheexch-client/banner/main-banner2.webp', 'https://sthiracdn.com/assets/radheexch-client/banner/main-banner3.webp', 'https://sthiracdn.com/assets/radheexch-client/banner/main-banner4.webp', 'https://sthiracdn.com/assets/radheexch-client/banner/main-banner5.webp']
        },
        {
            domain: '11dream247.com',
            apiDomain: '11dream247.com',
            name: '11dream247',
            dName: '11dream247',
            ext: '.com',
            theme: 'blue-body',
            email: '',
            pusher: {
                key: '76d7c55c2b5f8747ffd4',
                cluster: 'eu'
            },
            social: {
                isShow: false,
                whatsapp:'',
                facebook: '',
                instagram: '',
                telegram: '',
            },
            demoLoginWpLink: '',
            themePath: ['assets/css/theme-files/theme-master.css'],
            guestEnable: true,
            ftLivetvData: 'https://e765432.xyz/static/cc6c487c44b971286c3d0d1e24649619b4681674/getdata.php?chid=',
            afLoginRedirectUrl: '/dashboard',
            afterLoginNoticePath: '',
            newHomePage: false,
            isCustomBanner: false,
            demoLogin: true,
            depoWithdraw: false,
            downloadApk: '',
            iframeDomainUrl: '',
            signUpActive: false,
            tawkToSrc: '',
            footer: {
                isShow: true,
            },
            desktopBannerList: ['https://sthiracdn.com/assets/radheexch-client/banner/main-banner2.webp', 'https://sthiracdn.com/assets/radheexch-client/banner/main-banner3.webp', 'https://sthiracdn.com/assets/radheexch-client/banner/main-banner4.webp', 'https://sthiracdn.com/assets/radheexch-client/banner/main-banner5.webp'],
            mobileBannerList: ['https://sthiracdn.com/assets/radheexch-client/banner/main-banner2.webp', 'https://sthiracdn.com/assets/radheexch-client/banner/main-banner3.webp', 'https://sthiracdn.com/assets/radheexch-client/banner/main-banner4.webp', 'https://sthiracdn.com/assets/radheexch-client/banner/main-banner5.webp']
        },
        {
            domain: 'crex999.com',
            apiDomain: 'crex999.com',
            name: 'crex999',
            dName: 'crex999',
            ext: '.com',
            theme: 'blue-body',
            email: '',
            pusher: {
                key: '5b1dec503fbd6e8b176c',
                cluster: 'eu'
            },
            social: {
                isShow: false,
                whatsapp:'',
                facebook: '',
                instagram: '',
                telegram: '',
            },
            demoLoginWpLink: '',
            themePath: ['assets/css/theme-files/theme-master.css'],
            guestEnable: true,
            ftLivetvData: 'https://e765432.xyz/static/cc6c487c44b971286c3d0d1e24649619b4681674/getdata.php?chid=',
            afLoginRedirectUrl: '/dashboard',
            afterLoginNoticePath: '',
            newHomePage: false,
            isCustomBanner: false,
            demoLogin: true,
            depoWithdraw: false,
            downloadApk: '',
            iframeDomainUrl: '',
            signUpActive: false,
            tawkToSrc: '',
            footer: {
                isShow: true,
            },
            desktopBannerList: ['https://sthiracdn.com/assets/radheexch-client/banner/main-banner2.webp', 'https://sthiracdn.com/assets/radheexch-client/banner/main-banner3.webp', 'https://sthiracdn.com/assets/radheexch-client/banner/main-banner4.webp', 'https://sthiracdn.com/assets/radheexch-client/banner/main-banner5.webp'],
            mobileBannerList: ['https://sthiracdn.com/assets/radheexch-client/banner/main-banner2.webp', 'https://sthiracdn.com/assets/radheexch-client/banner/main-banner3.webp', 'https://sthiracdn.com/assets/radheexch-client/banner/main-banner4.webp', 'https://sthiracdn.com/assets/radheexch-client/banner/main-banner5.webp']
        },
        {
            domain: 'radheexch.me',
            apiDomain: 'radheexch.me',
            name: 'radheexch',
            dName: 'radheexch',
            ext: '.me',
            theme: 'blue-body',
            email: '',
            pusher: {
                key: '76d7c55c2b5f8747ffd4',
                cluster: 'eu'
            },
            social: {
                isShow: false,
                whatsapp:'',
                facebook: '',
                instagram: '',
                telegram: '',
            },
            demoLoginWpLink: 'https://awl247wa.com/casino/radhe',
            themePath: ['assets/css/theme-files/theme-master.css'],
            guestEnable: true,
            ftLivetvData: 'https://getscoredata.com/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
            afLoginRedirectUrl: '/dashboard',
            afterLoginNoticePath: 'https://sthiracdn.com/assets/popup/popup-radhe-apk-download2026.webp',
            newHomePage: false,
            isCustomBanner: false,
            demoLogin: true,
            depoWithdraw: true,
            downloadApk: 'https://allwhitelabel247.com/RadhaExchange.apk',
            iframeDomainUrl: 'https://99h.biz/',
            signUpActive: true,
            tawkToSrc: '',
            footer: {
                isShow: true,
            },
            desktopBannerList: ['https://sthiracdn.com/assets/radheexch-client/banner/main-banner2.webp', 'https://sthiracdn.com/assets/radheexch-client/banner/main-banner3.webp', 'https://sthiracdn.com/assets/radheexch-client/banner/main-banner4.webp', 'https://sthiracdn.com/assets/radheexch-client/banner/main-banner5.webp'],
            mobileBannerList: ['https://sthiracdn.com/assets/radheexch-client/banner/main-banner2.webp', 'https://sthiracdn.com/assets/radheexch-client/banner/main-banner3.webp', 'https://sthiracdn.com/assets/radheexch-client/banner/main-banner4.webp', 'https://sthiracdn.com/assets/radheexch-client/banner/main-banner5.webp']
        },
        {
            domain: 'naiduexchange.com',
            apiDomain: 'naiduexchange.com',
            name: 'naiduexchange',
            dName: 'naiduexchange',
            ext: '.com',
            theme: 'blue-body',
            email: '',
            pusher: {
                key: '76d7c55c2b5f8747ffd4',
                cluster: 'eu'
            },
            social: {
                isShow: false,
                whatsapp:'',
                facebook: '',
                instagram: '',
                telegram: '',
            },
            demoLoginWpLink: '',
            themePath: ['assets/css/theme-files/theme-master.css'],
            guestEnable: true,
            ftLivetvData: 'https://e765432.xyz/static/cc6c487c44b971286c3d0d1e24649619b4681674/getdata.php?chid=',
            afLoginRedirectUrl: '/dashboard',
            afterLoginNoticePath: '',
            newHomePage: false,
            isCustomBanner: false,
            demoLogin: true,
            depoWithdraw: true,
            downloadApk: '',
            iframeDomainUrl: 'https://99h.biz/',
            signUpActive: true,
            tawkToSrc: '',
            footer: {
                isShow: true,
            },
            desktopBannerList: ['https://sthiracdn.com/assets/radheexch-client/banner/main-banner2.webp', 'https://sthiracdn.com/assets/radheexch-client/banner/main-banner3.webp', 'https://sthiracdn.com/assets/radheexch-client/banner/main-banner4.webp', 'https://sthiracdn.com/assets/radheexch-client/banner/main-banner5.webp'],
            mobileBannerList: ['https://sthiracdn.com/assets/radheexch-client/banner/main-banner2.webp', 'https://sthiracdn.com/assets/radheexch-client/banner/main-banner3.webp', 'https://sthiracdn.com/assets/radheexch-client/banner/main-banner4.webp', 'https://sthiracdn.com/assets/radheexch-client/banner/main-banner5.webp']
        },
        {
            domain: 'parker777.site',
            apiDomain: 'parker777.io',
            name: 'parker777',
            dName: 'parker777',
            ext: '.site',
            theme: 'blue-body',
            email: '',
            pusher: {
                key: '76d7c55c2b5f8747ffd4',
                cluster: 'eu'
            },
            social: {
                isShow: false,
                whatsapp:'',
                facebook: '',
                instagram: '',
                telegram: '',
            },
            demoLoginWpLink: '',
            themePath: ['assets/css/theme-files/theme-master.css'],
            guestEnable: true,
            ftLivetvData: 'https://e765432.xyz/static/cc6c487c44b971286c3d0d1e24649619b4681674/getdata.php?chid=',
            afLoginRedirectUrl: '/dashboard',
            afterLoginNoticePath: '',
            newHomePage: false,
            isCustomBanner: false,
            demoLogin: true,
            depoWithdraw: true,
            downloadApk: '',
            iframeDomainUrl: 'https://99h.biz/',
            signUpActive: true,
            tawkToSrc: '',
            footer: {
                isShow: true,
            },
            desktopBannerList: ['https://sthiracdn.com/assets/radheexch-client/banner/main-banner2.webp', 'https://sthiracdn.com/assets/radheexch-client/banner/main-banner3.webp', 'https://sthiracdn.com/assets/radheexch-client/banner/main-banner4.webp', 'https://sthiracdn.com/assets/radheexch-client/banner/main-banner5.webp'],
            mobileBannerList: ['https://sthiracdn.com/assets/radheexch-client/banner/main-banner2.webp', 'https://sthiracdn.com/assets/radheexch-client/banner/main-banner3.webp', 'https://sthiracdn.com/assets/radheexch-client/banner/main-banner4.webp', 'https://sthiracdn.com/assets/radheexch-client/banner/main-banner5.webp']
        },
        {
            domain: 'radhe777.io',
            apiDomain: 'radhe777.io',
            name: 'radhe777',
            dName: 'radhe777',
            ext: '.io',
            theme: 'blue-body',
            email: '',
            pusher: {
                key: 'c8bbdb36496c73b41567',
                cluster: 'eu'
            },
            social: {
                isShow: false,
                whatsapp:'',
                facebook: '',
                instagram: '',
                telegram: '',
            },
            demoLoginWpLink: '',
            themePath: ['assets/css/theme-files/theme-master.css'],
            guestEnable: true,
            ftLivetvData: 'https://getscoredata.com/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
            afLoginRedirectUrl: '/dashboard',
            afterLoginNoticePath: '',
            newHomePage: false,
            isCustomBanner: false,
            demoLogin: true,
            depoWithdraw: true,
            downloadApk: '',
            iframeDomainUrl: 'https://99h.biz/',
            signUpActive: false,
            tawkToSrc: '',
            footer: {
                isShow: true,
            },
            desktopBannerList: ['https://sthiracdn.com/assets/radheexch-client/banner/main-banner2.webp', 'https://sthiracdn.com/assets/radheexch-client/banner/main-banner3.webp', 'https://sthiracdn.com/assets/radheexch-client/banner/main-banner4.webp', 'https://sthiracdn.com/assets/radheexch-client/banner/main-banner5.webp'],
            mobileBannerList: ['https://sthiracdn.com/assets/radheexch-client/banner/main-banner2.webp', 'https://sthiracdn.com/assets/radheexch-client/banner/main-banner3.webp', 'https://sthiracdn.com/assets/radheexch-client/banner/main-banner4.webp', 'https://sthiracdn.com/assets/radheexch-client/banner/main-banner5.webp']
        },
        {
            domain: 'radhe2.in',
            apiDomain: 'radhe2.in',
            name: 'radhe2',
            dName: 'radhe2',
            ext: '.in',
            theme: 'blue-body',
            email: '',
            pusher: {
                key: '76d7c55c2b5f8747ffd4',
                cluster: 'eu'
            },
            social: {
                isShow: false,
                whatsapp:'',
                facebook: '',
                instagram: '',
                telegram: '',
            },
            demoLoginWpLink: '',
            themePath: ['assets/css/theme-files/theme-master.css'],
            guestEnable: true,
            ftLivetvData: 'https://e765432.xyz/static/cc6c487c44b971286c3d0d1e24649619b4681674/getdata.php?chid=',
            afLoginRedirectUrl: '/dashboard',
            afterLoginNoticePath: '',
            newHomePage: false,
            isCustomBanner: false,
            demoLogin: true,
            depoWithdraw: false,
            downloadApk: '',
            iframeDomainUrl: 'https://99h.biz/',
            signUpActive: true,
            tawkToSrc: '',
            footer: {
                isShow: true,
            },
            desktopBannerList: ['https://sthiracdn.com/assets/radheexch-client/banner/main-banner2.webp', 'https://sthiracdn.com/assets/radheexch-client/banner/main-banner3.webp', 'https://sthiracdn.com/assets/radheexch-client/banner/main-banner4.webp', 'https://sthiracdn.com/assets/radheexch-client/banner/main-banner5.webp'],
            mobileBannerList: ['https://sthiracdn.com/assets/radheexch-client/banner/main-banner2.webp', 'https://sthiracdn.com/assets/radheexch-client/banner/main-banner3.webp', 'https://sthiracdn.com/assets/radheexch-client/banner/main-banner4.webp', 'https://sthiracdn.com/assets/radheexch-client/banner/main-banner5.webp']
        },
        {
            domain: 'sarpanchexchangeofficial.in',
            apiDomain: 'sarpanchexchangeofficial.in',
            name: 'sarpanchexchangeofficial',
            dName: 'sarpanchexchangeofficial',
            ext: '.in',
            theme: 'blue-body',
            email: '',
            pusher: {
                key: '76d7c55c2b5f8747ffd4',
                cluster: 'eu'
            },
            social: {
                isShow: false,
                whatsapp:'',
                facebook: '',
                instagram: '',
                telegram: '',
            },
            demoLoginWpLink: '',
            themePath: ['assets/css/theme-files/theme-master.css'],
            guestEnable: true,
            ftLivetvData: 'https://e765432.xyz/static/cc6c487c44b971286c3d0d1e24649619b4681674/getdata.php?chid=',
            afLoginRedirectUrl: '/dashboard',
            afterLoginNoticePath: '',
            newHomePage: false,
            isCustomBanner: false,
            demoLogin: true,
            depoWithdraw: false,
            downloadApk: '',
            iframeDomainUrl: '',
            signUpActive: false,
            tawkToSrc: '',
            footer: {
                isShow: true,
            },
            desktopBannerList: ['https://sthiracdn.com/assets/radheexch-client/banner/main-banner2.webp', 'https://sthiracdn.com/assets/radheexch-client/banner/main-banner3.webp', 'https://sthiracdn.com/assets/radheexch-client/banner/main-banner4.webp', 'https://sthiracdn.com/assets/radheexch-client/banner/main-banner5.webp'],
            mobileBannerList: ['https://sthiracdn.com/assets/radheexch-client/banner/main-banner2.webp', 'https://sthiracdn.com/assets/radheexch-client/banner/main-banner3.webp', 'https://sthiracdn.com/assets/radheexch-client/banner/main-banner4.webp', 'https://sthiracdn.com/assets/radheexch-client/banner/main-banner5.webp']
        },
        {
            domain: 'v247.co',
            apiDomain: 'v247.co',
            name: 'v247',
            dName: 'v247',
            ext: '.co',
            theme: 'blue-body',
            email: '',
            pusher: {
                key: 'c8bbdb36496c73b41567',
                cluster: 'eu'
            },
            social: {
                isShow: false,
                whatsapp:'',
                facebook: '',
                instagram: '',
                telegram: '',
            },
            demoLoginWpLink: '',
            themePath: ['assets/css/theme-files/theme-master.css'],
            guestEnable: true,
            ftLivetvData: 'https://e765432.xyz/static/cc6c487c44b971286c3d0d1e24649619b4681674/getdata.php?chid=',
            afLoginRedirectUrl: '/dashboard',
            afterLoginNoticePath: '',
            newHomePage: false,
            isCustomBanner: false,
            demoLogin: true,
            depoWithdraw: false,
            downloadApk: '',
            iframeDomainUrl: '',
            signUpActive: false,
            tawkToSrc: '',
            footer: {
                isShow: true,
            },
            desktopBannerList: ['https://sthiracdn.com/assets/radheexch-client/banner/main-banner2.webp', 'https://sthiracdn.com/assets/radheexch-client/banner/main-banner3.webp', 'https://sthiracdn.com/assets/radheexch-client/banner/main-banner4.webp', 'https://sthiracdn.com/assets/radheexch-client/banner/main-banner5.webp'],
            mobileBannerList: ['https://sthiracdn.com/assets/radheexch-client/banner/main-banner2.webp', 'https://sthiracdn.com/assets/radheexch-client/banner/main-banner3.webp', 'https://sthiracdn.com/assets/radheexch-client/banner/main-banner4.webp', 'https://sthiracdn.com/assets/radheexch-client/banner/main-banner5.webp']
        },
        {
            domain: 'rudraexch.live',
            apiDomain: 'rudraexch.live',
            name: 'rudraexch',
            dName: 'rudraexch',
            ext: '.live',
            theme: 'blue-body',
            email: '',
            pusher: {
                key: '76d7c55c2b5f8747ffd4',
                cluster: 'eu'
            },
            social: {
                isShow: false,
                whatsapp:'',
                facebook: '',
                instagram: '',
                telegram: '',
            },
            demoLoginWpLink: '',
            themePath: ['assets/css/theme-files/theme-pink.css'],
            guestEnable: true,
            ftLivetvData: 'https://getscoredata.com/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
            afLoginRedirectUrl: '/dashboard',
            afterLoginNoticePath: 'https://sthiracdn.com/assets/radheexch-client/popup-new.jpg',
            newHomePage: false,
            isCustomBanner: false,
            demoLogin: true,
            depoWithdraw: true,
            downloadApk: './assets/img/RadhaExchange.apk',
            iframeDomainUrl: 'https://99h.biz/',
            signUpActive: true,
            tawkToSrc: '',
            footer: {
                isShow: true,
            },
            desktopBannerList: ['https://sthiracdn.com/assets/radheexch-client/banner/main-banner2.webp', 'https://sthiracdn.com/assets/radheexch-client/banner/main-banner3.webp', 'https://sthiracdn.com/assets/radheexch-client/banner/main-banner4.webp', 'https://sthiracdn.com/assets/radheexch-client/banner/main-banner5.webp'],
            mobileBannerList: ['https://sthiracdn.com/assets/radheexch-client/banner/main-banner2.webp', 'https://sthiracdn.com/assets/radheexch-client/banner/main-banner3.webp', 'https://sthiracdn.com/assets/radheexch-client/banner/main-banner4.webp', 'https://sthiracdn.com/assets/radheexch-client/banner/main-banner5.webp']
        },
        {
            domain: 'playnwin247.com',
            apiDomain: 'playnwin247.com',
            name: 'playnwin247',
            dName: 'playnwin247',
            ext: '.com',
            theme: 'blue-body',
            email: '',
            pusher: {
                key: '30d84d922854368d449e',
                cluster: 'eu'
            },
            social: {
                isShow: false,
                whatsapp:'',
                facebook: '',
                instagram: '',
                telegram: '',
            },
            demoLoginWpLink: '',
            themePath: ['assets/css/theme-files/theme-master.css'],
            guestEnable: true,
            ftLivetvData: 'https://getscoredata.com/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
            afLoginRedirectUrl: '/dashboard',
            afterLoginNoticePath: 'https://sthiracdn.com/assets/radheexch-client/popup-new.jpg',
            newHomePage: false,
            isCustomBanner: false,
            demoLogin: true,
            depoWithdraw: true,
            downloadApk: '',
            iframeDomainUrl: 'https://77panel.io/',
            signUpActive: true,
            tawkToSrc: '',
            footer: {
                isShow: false,
            },
            desktopBannerList: ['https://sthiracdn.com/assets/radheexch-client/banner/main-banner2.webp', 'https://sthiracdn.com/assets/radheexch-client/banner/main-banner3.webp', 'https://sthiracdn.com/assets/radheexch-client/banner/main-banner4.webp', 'https://sthiracdn.com/assets/radheexch-client/banner/main-banner5.webp'],
            mobileBannerList: ['https://sthiracdn.com/assets/radheexch-client/banner/main-banner2.webp', 'https://sthiracdn.com/assets/radheexch-client/banner/main-banner3.webp', 'https://sthiracdn.com/assets/radheexch-client/banner/main-banner4.webp', 'https://sthiracdn.com/assets/radheexch-client/banner/main-banner5.webp']
        },
        {
            domain: 'palexch.com',
            apiDomain: 'palexch.com',
            name: 'palexch',
            dName: 'palexch',
            ext: '.com',
            theme: 'blue-body',
            email: '',
            pusher: {
                key: '30d84d922854368d449e',
                cluster: 'eu'
            },
            social: {
                isShow: false,
                whatsapp:'',
                facebook: '',
                instagram: '',
                telegram: '',
            },
            demoLoginWpLink: '',
            themePath: ['assets/css/theme-files/theme-master.css'],
            guestEnable: true,
            ftLivetvData: 'https://getscoredata.com/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
            afLoginRedirectUrl: '/dashboard',
            afterLoginNoticePath: 'https://sthiracdn.com/assets/radheexch-client/popup-new.jpg',
            newHomePage: false,
            isCustomBanner: false,
            demoLogin: true,
            depoWithdraw: true,
            downloadApk: '',
            iframeDomainUrl: 'https://77panel.io/',
            signUpActive: false,
            tawkToSrc: '',
            footer: {
                isShow: false,
            },
            desktopBannerList: ['https://sthiracdn.com/assets/radheexch-client/banner/main-banner2.webp', 'https://sthiracdn.com/assets/radheexch-client/banner/main-banner3.webp', 'https://sthiracdn.com/assets/radheexch-client/banner/main-banner4.webp', 'https://sthiracdn.com/assets/radheexch-client/banner/main-banner5.webp'],
            mobileBannerList: ['https://sthiracdn.com/assets/radheexch-client/banner/main-banner2.webp', 'https://sthiracdn.com/assets/radheexch-client/banner/main-banner3.webp', 'https://sthiracdn.com/assets/radheexch-client/banner/main-banner4.webp', 'https://sthiracdn.com/assets/radheexch-client/banner/main-banner5.webp']
        },
        {
            domain: 'palexch365.com',
            apiDomain: 'palexch365.com',
            name: 'palexch365',
            dName: 'palexch365',
            ext: '.com',
            theme: 'blue-body',
            email: '',
            pusher: {
                key: '30d84d922854368d449e',
                cluster: 'eu'
            },
            social: {
                isShow: false,
                whatsapp:'',
                facebook: '',
                instagram: '',
                telegram: '',
            },
            demoLoginWpLink: '',
            themePath: ['assets/css/theme-files/theme-master.css'],
            guestEnable: true,
            ftLivetvData: 'https://getscoredata.com/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
            afLoginRedirectUrl: '/dashboard',
            afterLoginNoticePath: 'https://sthiracdn.com/assets/radheexch-client/popup-new.jpg',
            newHomePage: false,
            isCustomBanner: false,
            demoLogin: true,
            depoWithdraw: true,
            downloadApk: '',
            iframeDomainUrl: 'https://panel.freeplay24.com/',
            signUpActive: true,
            tawkToSrc: '',
            footer: {
                isShow: false,
            },
            desktopBannerList: ['https://static-content-banners.s3.ap-south-1.amazonaws.com/radhe/desktop/bnr1-min-test-img.png', 'https://static-content-banners.s3.ap-south-1.amazonaws.com/radhe/desktop/bnr3-min-test-img.png', 'https://static-content-banners.s3.ap-south-1.amazonaws.com/radhe/desktop/bnr4-min-test-img.png'],
            mobileBannerList: ['https://static-content-banners.s3.ap-south-1.amazonaws.com/radhe/mobile/bnr1-min-test-img.png', 'https://static-content-banners.s3.ap-south-1.amazonaws.com/radhe/mobile/bnr2-min-test-img.png', 'https://static-content-banners.s3.ap-south-1.amazonaws.com/radhe/mobile/bnr3-min-test-img.png', 'https://static-content-banners.s3.ap-south-1.amazonaws.com/radhe/mobile/bnr4-min-test-img.png']
        },
        {
            domain: 'taj555.co',
            apiDomain: 'taj555.co',
            name: 'taj555',
            dName: 'taj555',
            ext: '.co',
            theme: 'blue-body',
            email: '',
            pusher: {
                key: '30d84d922854368d449e',
                cluster: 'eu'
            },
            social: {
                isShow: false,
                whatsapp:'',
                facebook: '',
                instagram: '',
                telegram: '',
            },
            demoLoginWpLink: '',
            themePath: ['assets/css/theme-files/theme-master.css'],
            guestEnable: true,
            ftLivetvData: 'https://getscoredata.com/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
            afLoginRedirectUrl: '/dashboard',
            afterLoginNoticePath: '',
            newHomePage: false,
            isCustomBanner: false,
            demoLogin: true,
            depoWithdraw: true,
            downloadApk: '',
            iframeDomainUrl: 'https://panel.freeplay24.com/',
            signUpActive: false,
            tawkToSrc: '',
            footer: {
                isShow: false,
            },
            desktopBannerList: ['https://static-content-banners.s3.ap-south-1.amazonaws.com/radhe/desktop/bnr1-min-test-img.png', 'https://static-content-banners.s3.ap-south-1.amazonaws.com/radhe/desktop/bnr3-min-test-img.png', 'https://static-content-banners.s3.ap-south-1.amazonaws.com/radhe/desktop/bnr4-min-test-img.png'],
            mobileBannerList: ['https://static-content-banners.s3.ap-south-1.amazonaws.com/radhe/mobile/bnr1-min-test-img.png', 'https://static-content-banners.s3.ap-south-1.amazonaws.com/radhe/mobile/bnr2-min-test-img.png', 'https://static-content-banners.s3.ap-south-1.amazonaws.com/radhe/mobile/bnr3-min-test-img.png', 'https://static-content-banners.s3.ap-south-1.amazonaws.com/radhe/mobile/bnr4-min-test-img.png']
        },
        {
            domain: 'dhamaalexchange.net',
            apiDomain: 'dhamaalexchange.net',
            name: 'dhamaalexchange',
            dName: 'dhamaalexchange',
            ext: '.net',
            theme: 'blue-body',
            email: '',
            pusher: {
                key: '76d7c55c2b5f8747ffd4',
                cluster: 'eu'
            },
            social: {
                isShow: true,
                whatsapp:'https://wa.link/a0bo48',
                facebook: 'https://www.facebook.com/share/17oMxp9fq3/',
                instagram: 'https://www.instagram.com/dhamaal_exchange?igsh=MTRhN21paTNqcDR6Nw==',
                telegram: 'https://t.me/dhamalexch',
            },
            demoLoginWpLink: 'https://go.wa.link/dhamaalexchange',
            themePath: ['assets/css/theme-files/theme-red.css'],
            guestEnable: true,
            ftLivetvData: 'https://getscoredata.com/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
            afLoginRedirectUrl: '/dashboard',
            afterLoginNoticePath: 'https://sthiracdn.com/assets/radheexch-client/popup-new.jpg',
            newHomePage: false,
            isCustomBanner: false,
            demoLogin: true,
            depoWithdraw: true,
            downloadApk: '',
            iframeDomainUrl: 'https://99h.biz/',
            signUpActive: true,
            tawkToSrc: '',
            footer: {
                isShow: true,
            },
            desktopBannerList: ['https://static-content-banners.s3.ap-south-1.amazonaws.com/radhe/desktop/bnr1-min-test-img.png', 'https://static-content-banners.s3.ap-south-1.amazonaws.com/radhe/desktop/bnr3-min-test-img.png', 'https://static-content-banners.s3.ap-south-1.amazonaws.com/radhe/desktop/bnr4-min-test-img.png'],
            mobileBannerList: ['https://static-content-banners.s3.ap-south-1.amazonaws.com/radhe/mobile/bnr1-min-test-img.png', 'https://static-content-banners.s3.ap-south-1.amazonaws.com/radhe/mobile/bnr2-min-test-img.png', 'https://static-content-banners.s3.ap-south-1.amazonaws.com/radhe/mobile/bnr3-min-test-img.png', 'https://static-content-banners.s3.ap-south-1.amazonaws.com/radhe/mobile/bnr4-min-test-img.png']
        },
        {
            domain: 'dhamaalexchange.org',
            apiDomain: 'dhamaalexchange.org',
            name: 'dhamaalexchange',
            dName: 'dhamaalexchange',
            ext: '.org',
            theme: 'blue-body',
            email: '',
            pusher: {
                key: '76d7c55c2b5f8747ffd4',
                cluster: 'eu'
            },
            social: {
                isShow: true,
                whatsapp:'https://wa.link/a0bo48',
                facebook: 'https://www.facebook.com/share/17oMxp9fq3/',
                instagram: 'https://www.instagram.com/dhamaal_exchange?igsh=MTRhN21paTNqcDR6Nw==',
                telegram: 'https://t.me/dhamalexch',
            },
            demoLoginWpLink: 'https://go.wa.link/dhamaalexchange',
            themePath: ['assets/css/theme-files/theme-red.css'],
            guestEnable: true,
            ftLivetvData: 'https://getscoredata.com/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
            afLoginRedirectUrl: '/dashboard',
            afterLoginNoticePath: 'https://sthiracdn.com/assets/radheexch-client/popup-new.jpg',
            newHomePage: false,
            isCustomBanner: false,
            demoLogin: true,
            depoWithdraw: true,
            downloadApk: '',
            iframeDomainUrl: 'https://99h.biz/',
            signUpActive: true,
            tawkToSrc: '',
            footer: {
                isShow: true,
            },
            desktopBannerList: ['https://static-content-banners.s3.ap-south-1.amazonaws.com/radhe/desktop/bnr1-min-test-img.png', 'https://static-content-banners.s3.ap-south-1.amazonaws.com/radhe/desktop/bnr3-min-test-img.png', 'https://static-content-banners.s3.ap-south-1.amazonaws.com/radhe/desktop/bnr4-min-test-img.png'],
            mobileBannerList: ['https://static-content-banners.s3.ap-south-1.amazonaws.com/radhe/mobile/bnr1-min-test-img.png', 'https://static-content-banners.s3.ap-south-1.amazonaws.com/radhe/mobile/bnr2-min-test-img.png', 'https://static-content-banners.s3.ap-south-1.amazonaws.com/radhe/mobile/bnr3-min-test-img.png', 'https://static-content-banners.s3.ap-south-1.amazonaws.com/radhe/mobile/bnr4-min-test-img.png']
        },
        {
            domain: 'kheloindia.info',
            apiDomain: 'kheloindia.info',
            name: 'kheloindia',
            dName: 'kheloindia',
            ext: '.info',
            theme: 'blue-body',
            email: '',
            pusher: {
                key: '76d7c55c2b5f8747ffd4',
                cluster: 'eu'
            },
            social: {
                isShow: true,
                whatsapp:'',
                facebook: '',
                instagram: 'https://instagram.com/kheloindia.info',
                telegram: 'https://t.me/Kheloindiainfo',
            },
            demoLoginWpLink: 'https://wa.me/qr/DOQTBJXOBUWMD1',
            themePath: ['assets/css/theme-files/theme-yellow.css'],
            guestEnable: true,
            ftLivetvData: 'https://getscoredata.com/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
            afLoginRedirectUrl: '/dashboard',
            afterLoginNoticePath: 'https://sthiracdn.com/assets/popup/apk-download.webp',
            newHomePage: false,
            isCustomBanner: false,
            demoLogin: true,
            depoWithdraw: true,
            downloadApk: 'https://allwhitelabel247.com/KheloIndia.apk',
            iframeDomainUrl: 'https://99h.biz/',
            signUpActive: true,
            tawkToSrc: '',
            footer: {
                isShow: true,
            },
            desktopBannerList: ['https://sthiracdn.com/assets/radheexch-client/banner/main-banner2.webp', 'https://sthiracdn.com/assets/radheexch-client/banner/main-banner3.webp', 'https://sthiracdn.com/assets/radheexch-client/banner/main-banner4.webp', 'https://sthiracdn.com/assets/radheexch-client/banner/main-banner5.webp'],
            mobileBannerList: ['https://sthiracdn.com/assets/radheexch-client/banner/main-banner2.webp', 'https://sthiracdn.com/assets/radheexch-client/banner/main-banner3.webp', 'https://sthiracdn.com/assets/radheexch-client/banner/main-banner4.webp', 'https://sthiracdn.com/assets/radheexch-client/banner/main-banner5.webp']
        },
        {
            domain: 'swastik555.com',
            apiDomain: 'swastik555.com',
            name: 'swastik555',
            dName: 'swastik555',
            ext: '.com',
            theme: 'blue-body',
            email: '',
            pusher: {
                key: 'c8bbdb36496c73b41567',
                cluster: 'eu'
            },
            social: {
                isShow: false,
                whatsapp:'',
                facebook: '',
                instagram: '',
                telegram: '',
            },
            demoLoginWpLink: '',
            themePath: ['assets/css/theme-files/theme-blue.css'],
            guestEnable: true,
            ftLivetvData: 'https://getscoredata.com/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
            afLoginRedirectUrl: '/dashboard',
            afterLoginNoticePath: '',
            newHomePage: false,
            isCustomBanner: false,
            demoLogin: true,
            depoWithdraw: true,
            downloadApk: '',
            iframeDomainUrl: 'https://77panel.io/',
            signUpActive: true,
            tawkToSrc: '',
            footer: {
                isShow: true,
            },
            desktopBannerList: ['https://sthiracdn.com/assets/radheexch-client/banner/main-banner2.webp', 'https://sthiracdn.com/assets/radheexch-client/banner/main-banner3.webp', 'https://sthiracdn.com/assets/radheexch-client/banner/main-banner4.webp', 'https://sthiracdn.com/assets/radheexch-client/banner/main-banner5.webp'],
            mobileBannerList: ['https://sthiracdn.com/assets/radheexch-client/banner/main-banner2.webp', 'https://sthiracdn.com/assets/radheexch-client/banner/main-banner3.webp', 'https://sthiracdn.com/assets/radheexch-client/banner/main-banner4.webp', 'https://sthiracdn.com/assets/radheexch-client/banner/main-banner5.webp']
        },
        {
            domain: 'cricplay777.com',
            apiDomain: 'cricplay777.com',
            name: 'cricplay777',
            dName: 'cricplay777',
            ext: '.com',
            theme: 'blue-body',
            email: '',
            pusher: {
                key: '30d84d922854368d449e',
                cluster: 'eu'
            },
            social: {
                isShow: false,
                whatsapp:'',
                facebook: '',
                instagram: '',
                telegram: '',
            },
            demoLoginWpLink: 'https://api.whatsapp.com/send?phone=919180509942&text=Hy',
            themePath: ['assets/css/theme-files/theme-yellow.css'],
            guestEnable: true,
            ftLivetvData: 'https://getscoredata.com/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
            afLoginRedirectUrl: '/dashboard',
            afterLoginNoticePath: 'https://sthiracdn.com/assets/popup/popup-casino-fifa2026-new2.webp',
            newHomePage: false,
            isCustomBanner: false,
            demoLogin: true,
            depoWithdraw: true,
            downloadApk: '',
            iframeDomainUrl: 'https://77panel.io/',
            signUpActive: true,
            tawkToSrc: '',
            footer: {
                isShow: false,
            },
            desktopBannerList: ['https://sthiracdn.com/assets/radheexch-client/banner/main-banner2.webp', 'https://sthiracdn.com/assets/radheexch-client/banner/main-banner3.webp', 'https://sthiracdn.com/assets/radheexch-client/banner/main-banner4.webp', 'https://sthiracdn.com/assets/radheexch-client/banner/main-banner5.webp'],
            mobileBannerList: ['https://sthiracdn.com/assets/radheexch-client/banner/main-banner2.webp', 'https://sthiracdn.com/assets/radheexch-client/banner/main-banner3.webp', 'https://sthiracdn.com/assets/radheexch-client/banner/main-banner4.webp', 'https://sthiracdn.com/assets/radheexch-client/banner/main-banner5.webp']
        },
        {
            domain: 'mahaveerbook.info',
            apiDomain: 'mahaveerbook.info',
            name: 'mahaveerbook',
            dName: 'mahaveerbook',
            ext: '.info',
            theme: 'blue-body',
            email: '',
            pusher: {
                key: '76d7c55c2b5f8747ffd4',
                cluster: 'eu'
            },
            social: {
                isShow: false,
                whatsapp:'',
                facebook: '',
                instagram: '',
                telegram: '',
            },
            demoLoginWpLink: '',
            themePath: ['assets/css/theme-files/theme-master.css'],
            guestEnable: true,
            ftLivetvData: 'https://getscoredata.com/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
            afLoginRedirectUrl: '/dashboard',
            afterLoginNoticePath: 'https://sthiracdn.com/assets/popup/ipl2026-popup.jpg',
            newHomePage: false,
            isCustomBanner: false,
            demoLogin: true,
            depoWithdraw: true,
            downloadApk: '',
            iframeDomainUrl: 'https://panel.freeplay24.com/',
            signUpActive: true,
            tawkToSrc: '',
            footer: {
                isShow: false,
            },
            desktopBannerList: ['https://static-content-banners.s3.ap-south-1.amazonaws.com/radhe/desktop/bnr1-min-test-img.png', 'https://static-content-banners.s3.ap-south-1.amazonaws.com/radhe/desktop/bnr3-min-test-img.png', 'https://static-content-banners.s3.ap-south-1.amazonaws.com/radhe/desktop/bnr4-min-test-img.png'],
            mobileBannerList: ['https://static-content-banners.s3.ap-south-1.amazonaws.com/radhe/mobile/bnr1-min-test-img.png', 'https://static-content-banners.s3.ap-south-1.amazonaws.com/radhe/mobile/bnr2-min-test-img.png', 'https://static-content-banners.s3.ap-south-1.amazonaws.com/radhe/mobile/bnr3-min-test-img.png', 'https://static-content-banners.s3.ap-south-1.amazonaws.com/radhe/mobile/bnr4-min-test-img.png']
        },
        {
            domain: 'mahaveerbook.club',
            apiDomain: 'mahaveerbook.club',
            name: 'mahaveerbookclub',
            dName: 'mahaveerbookclub',
            ext: '.club',
            theme: 'blue-body',
            email: '',
            pusher: {
                key: '76d7c55c2b5f8747ffd4',
                cluster: 'eu'
            },
            social: {
                isShow: false,
                whatsapp:'',
                facebook: '',
                instagram: '',
                telegram: '',
            },
            demoLoginWpLink: '',
            themePath: ['assets/css/theme-files/theme-master.css'],
            guestEnable: true,
            ftLivetvData: 'https://getscoredata.com/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
            afLoginRedirectUrl: '/dashboard',
            afterLoginNoticePath: 'https://sthiracdn.com/assets/popup/ipl2026-popup.jpg',
            newHomePage: false,
            isCustomBanner: false,
            demoLogin: true,
            depoWithdraw: true,
            downloadApk: './assets/img/RadhaExchange.apk',
            iframeDomainUrl: 'https://panel.freeplay24.com/',
            signUpActive: true,
            tawkToSrc: '',
            footer: {
                isShow: true,
            },
            desktopBannerList: ['https://sthiracdn.com/assets/radheexch-client/banner/main-banner2.webp', 'https://sthiracdn.com/assets/radheexch-client/banner/main-banner3.webp', 'https://sthiracdn.com/assets/radheexch-client/banner/main-banner4.webp', 'https://sthiracdn.com/assets/radheexch-client/banner/main-banner5.webp'],
            mobileBannerList: ['https://sthiracdn.com/assets/radheexch-client/banner/main-banner2.webp', 'https://sthiracdn.com/assets/radheexch-client/banner/main-banner3.webp', 'https://sthiracdn.com/assets/radheexch-client/banner/main-banner4.webp', 'https://sthiracdn.com/assets/radheexch-client/banner/main-banner5.webp']
        },
        {
            domain: 'mahaveeronline.club',
            apiDomain: 'mahaveeronline.club',
            name: 'mahaveeronline',
            dName: 'mahaveeronline',
            ext: '.club',
            theme: 'blue-body',
            email: '',
            pusher: {
                key: '76d7c55c2b5f8747ffd4',
                cluster: 'eu'
            },
            social: {
                isShow: false,
                whatsapp:'',
                facebook: '',
                instagram: '',
                telegram: '',
            },
            demoLoginWpLink: '',
            themePath: ['assets/css/theme-files/theme-master.css'],
            guestEnable: true,
            ftLivetvData: 'https://getscoredata.com/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
            afLoginRedirectUrl: '/dashboard',
            afterLoginNoticePath: 'https://sthiracdn.com/assets/popup/ipl2026-popup.jpg',
            newHomePage: false,
            isCustomBanner: false,
            demoLogin: true,
            depoWithdraw: true,
            downloadApk: '',
            iframeDomainUrl: 'https://panel.freeplay24.com/',
            signUpActive: true,
            tawkToSrc: '',
            footer: {
                isShow: true,
            },
            desktopBannerList: ['https://static-content-banners.s3.ap-south-1.amazonaws.com/radhe/desktop/bnr1-min-test-img.png', 'https://static-content-banners.s3.ap-south-1.amazonaws.com/radhe/desktop/bnr3-min-test-img.png', 'https://static-content-banners.s3.ap-south-1.amazonaws.com/radhe/desktop/bnr4-min-test-img.png'],
            mobileBannerList: ['https://static-content-banners.s3.ap-south-1.amazonaws.com/radhe/mobile/bnr1-min-test-img.png', 'https://static-content-banners.s3.ap-south-1.amazonaws.com/radhe/mobile/bnr2-min-test-img.png', 'https://static-content-banners.s3.ap-south-1.amazonaws.com/radhe/mobile/bnr3-min-test-img.png', 'https://static-content-banners.s3.ap-south-1.amazonaws.com/radhe/mobile/bnr4-min-test-img.png']
        },
        {
            domain: 'bluediamond247.com',
            apiDomain: 'bluediamond247.com',
            name: 'bluediamond247',
            dName: 'bluediamond247',
            ext: '.com',
            theme: 'blue-body',
            email: '',
            pusher: {
                key: '30d84d922854368d449e',
                cluster: 'eu'
            },
            social: {
                isShow: false,
                whatsapp:'',
                facebook: '',
                instagram: '',
                telegram: '',
            },
            demoLoginWpLink: '',
            themePath: ['assets/css/theme-files/theme-master.css'],
            guestEnable: true,
            ftLivetvData: 'https://getscoredata.com/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
            afLoginRedirectUrl: '/dashboard',
            afterLoginNoticePath: 'https://sthiracdn.com/assets/popup/popup-casino-fifa2026-new2.webp',
            newHomePage: false,
            isCustomBanner: false,
            demoLogin: true,
            depoWithdraw: true,
            downloadApk: '',
            iframeDomainUrl: 'https://77panel.io/',
            signUpActive: true,
            tawkToSrc: '',
            footer: {
                isShow: false,
            },
            desktopBannerList: ['https://static-content-banners.s3.ap-south-1.amazonaws.com/radhe/desktop/bnr1-min-test-img.png', 'https://static-content-banners.s3.ap-south-1.amazonaws.com/radhe/desktop/bnr3-min-test-img.png', 'https://static-content-banners.s3.ap-south-1.amazonaws.com/radhe/desktop/bnr4-min-test-img.png'],
            mobileBannerList: ['https://static-content-banners.s3.ap-south-1.amazonaws.com/radhe/mobile/bnr1-min-test-img.png', 'https://static-content-banners.s3.ap-south-1.amazonaws.com/radhe/mobile/bnr2-min-test-img.png', 'https://static-content-banners.s3.ap-south-1.amazonaws.com/radhe/mobile/bnr3-min-test-img.png', 'https://static-content-banners.s3.ap-south-1.amazonaws.com/radhe/mobile/bnr4-min-test-img.png']
        },
        {
            domain: 'srinoida.xyz',
            apiDomain: 'srinoida.xyz',
            name: 'srinoida',
            dName: 'srinoida',
            ext: '.xyz',
            theme: 'blue-body',
            email: '',
            pusher: {
                key: '30d84d922854368d449e',
                cluster: 'eu'
            },
            social: {
                isShow: false,
                whatsapp:'',
                facebook: '',
                instagram: '',
                telegram: '',
            },
            demoLoginWpLink: '',
            themePath: ['assets/css/theme-files/theme-master.css'],
            guestEnable: true,
            ftLivetvData: 'https://getscoredata.com/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
            afLoginRedirectUrl: '/dashboard',
            afterLoginNoticePath: 'https://sthiracdn.com/assets/radheexch-client/popup-new.jpg',
            newHomePage: false,
            isCustomBanner: false,
            demoLogin: true,
            depoWithdraw: true,
            downloadApk: '',
            iframeDomainUrl: 'https://77panel.io/',
            signUpActive: true,
            tawkToSrc: '',
            footer: {
                isShow: false,
            },
            desktopBannerList: ['https://static-content-banners.s3.ap-south-1.amazonaws.com/radhe/desktop/bnr1-min-test-img.png', 'https://static-content-banners.s3.ap-south-1.amazonaws.com/radhe/desktop/bnr3-min-test-img.png', 'https://static-content-banners.s3.ap-south-1.amazonaws.com/radhe/desktop/bnr4-min-test-img.png'],
            mobileBannerList: ['https://static-content-banners.s3.ap-south-1.amazonaws.com/radhe/mobile/bnr1-min-test-img.png', 'https://static-content-banners.s3.ap-south-1.amazonaws.com/radhe/mobile/bnr2-min-test-img.png', 'https://static-content-banners.s3.ap-south-1.amazonaws.com/radhe/mobile/bnr3-min-test-img.png', 'https://static-content-banners.s3.ap-south-1.amazonaws.com/radhe/mobile/bnr4-min-test-img.png']
        },
        {
            domain: 'royal230.com',
            apiDomain: 'royal230.com',
            name: 'royal230',
            dName: 'royal230',
            ext: '.com',
            theme: 'blue-body',
            email: '',
            pusher: {
                key: 'c8bbdb36496c73b41567',
                cluster: 'eu'
            },
            social: {
                isShow: false,
                whatsapp:'',
                facebook: '',
                instagram: '',
                telegram: '',
            },
            demoLoginWpLink: '',
            themePath: ['assets/css/theme-files/theme-master.css'],
            guestEnable: true,
            ftLivetvData: 'https://getscoredata.com/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
            afLoginRedirectUrl: '/dashboard',
            afterLoginNoticePath: '',
            newHomePage: false,
            isCustomBanner: false,
            demoLogin: true,
            depoWithdraw: true,
            downloadApk: '',
            iframeDomainUrl: 'https://99h.biz/',
            signUpActive: false,
            tawkToSrc: '',
            footer: {
                isShow: true,
            },
            desktopBannerList: ['https://static-content-banners.s3.ap-south-1.amazonaws.com/parker/desktop/bnr1-min.png','https://static-content-banners.s3.ap-south-1.amazonaws.com/parker/desktop/bnr2-min.png','https://static-content-banners.s3.ap-south-1.amazonaws.com/parker/desktop/bnr3-min.png','https://static-content-banners.s3.ap-south-1.amazonaws.com/parker/desktop/bnr4-min.png','https://static-content-banners.s3.ap-south-1.amazonaws.com/parker/desktop/bnr5-min.png'],
            mobileBannerList: ['https://static-content-banners.s3.ap-south-1.amazonaws.com/parker/mobile/bnr1-min.png','https://static-content-banners.s3.ap-south-1.amazonaws.com/parker/mobile/bnr2-min.png','https://static-content-banners.s3.ap-south-1.amazonaws.com/parker/mobile/bnr3-min.png','https://static-content-banners.s3.ap-south-1.amazonaws.com/parker/mobile/bnr4-min.png','https://static-content-banners.s3.ap-south-1.amazonaws.com/parker/mobile/bnr5-min.png']
        },
        {
            domain: 'shreenath777.com',
            apiDomain: 'shreenath777.com',
            name: 'shreenath777',
            dName: 'shreenath777',
            ext: '.com',
            theme: 'blue-body',
            email: '',
            pusher: {
                key: '30d84d922854368d449e',
                cluster: 'eu'
            },
            social: {
                isShow: false,
                whatsapp:'',
                facebook: '',
                instagram: '',
                telegram: '',
            },
            demoLoginWpLink: '',
            themePath: ['assets/css/theme-files/theme-master.css'],
            guestEnable: true,
            ftLivetvData: 'https://getscoredata.com/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
            afLoginRedirectUrl: '/dashboard',
            afterLoginNoticePath: 'https://sthiracdn.com/assets/radheexch-client/popup-new.jpg',
            newHomePage: false,
            isCustomBanner: false,
            demoLogin: true,
            depoWithdraw: true,
            downloadApk: '',
            iframeDomainUrl: 'https://77panel.io/',
            signUpActive: true,
            tawkToSrc: '',
            footer: {
                isShow: false,
            },
            desktopBannerList: ['https://static-content-banners.s3.ap-south-1.amazonaws.com/radhe/desktop/bnr1-min-test-img.png', 'https://static-content-banners.s3.ap-south-1.amazonaws.com/radhe/desktop/bnr3-min-test-img.png', 'https://static-content-banners.s3.ap-south-1.amazonaws.com/radhe/desktop/bnr4-min-test-img.png'],
            mobileBannerList: ['https://static-content-banners.s3.ap-south-1.amazonaws.com/radhe/mobile/bnr1-min-test-img.png', 'https://static-content-banners.s3.ap-south-1.amazonaws.com/radhe/mobile/bnr2-min-test-img.png', 'https://static-content-banners.s3.ap-south-1.amazonaws.com/radhe/mobile/bnr3-min-test-img.png', 'https://static-content-banners.s3.ap-south-1.amazonaws.com/radhe/mobile/bnr4-min-test-img.png']
        },
        {
            domain: 'rajahuli99.com',
            apiDomain: 'alexisly.com',
            name: 'rajahuli99',
            dName: 'rajahuli99',
            ext: '.com',
            theme: 'blue-body',
            email: '',
            pusher: {
                key: '76d7c55c2b5f8747ffd4',
                cluster: 'eu'
            },
            social: {
                isShow: true,
                whatsapp:'https://awl247wa.com/business/allrounder99',
                facebook: '',
                instagram: '',
                telegram: '',
            },
            demoLoginWpLink: 'https://awl247wa.com/business/allrounder99',
            themePath: ['assets/css/theme-files/theme-red.css'],
            guestEnable: true,
            ftLivetvData: 'https://getscoredata.com/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
            afLoginRedirectUrl: '/dashboard',
            afterLoginNoticePath: '',
            newHomePage: false,
            isCustomBanner: false,
            demoLogin: true,
            depoWithdraw: true,
            downloadApk: '',
            iframeDomainUrl: 'https://panel.freeplay24.com/',
            signUpActive: true,
            tawkToSrc: 'https://embed.tawk.to/6a7fe0e45981892f72ddd29b/default',
            footer: {
                isShow: true,
            },
            desktopBannerList: ['https://static-content-banners.s3.ap-south-1.amazonaws.com/radhe/desktop/bnr1-min-test-img.png', 'https://static-content-banners.s3.ap-south-1.amazonaws.com/radhe/desktop/bnr3-min-test-img.png', 'https://static-content-banners.s3.ap-south-1.amazonaws.com/radhe/desktop/bnr4-min-test-img.png'],
            mobileBannerList: ['https://static-content-banners.s3.ap-south-1.amazonaws.com/radhe/mobile/bnr1-min-test-img.png', 'https://static-content-banners.s3.ap-south-1.amazonaws.com/radhe/mobile/bnr2-min-test-img.png', 'https://static-content-banners.s3.ap-south-1.amazonaws.com/radhe/mobile/bnr3-min-test-img.png', 'https://static-content-banners.s3.ap-south-1.amazonaws.com/radhe/mobile/bnr4-min-test-img.png']
        },
        {
            domain: 'radheexch.online',
            apiDomain: 'alexisly.com',
            name: 'radheexch',
            dName: 'radheexch',
            ext: '.online',
            theme: 'blue-body',
            email: '',
            pusher: {
                key: '76d7c55c2b5f8747ffd4',
                cluster: 'eu'
            },
            social: {
                isShow: false,
                whatsapp:'',
                facebook: '',
                instagram: '',
                telegram: '',
            },
            demoLoginWpLink: 'https://awl247wa.com/casino/radhe',
            themePath: ['assets/css/theme-files/theme-master.css'],
            guestEnable: true,
            ftLivetvData: 'https://getscoredata.com/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
            afLoginRedirectUrl: '/dashboard',
            afterLoginNoticePath: 'https://sthiracdn.com/assets/popup/popup-radhe-apk-download2026.webp',
            newHomePage: false,
            isCustomBanner: false,
            demoLogin: true,
            depoWithdraw: true,
            downloadApk: 'https://allwhitelabel247.com/RadhaExchange.apk',
            iframeDomainUrl: 'https://99h.biz/',
            signUpActive: true,
            tawkToSrc: '',
            footer: {
                isShow: true,
            },
            desktopBannerList: ['https://sthiracdn.com/assets/radheexch-client/banner/main-banner2.webp', 'https://sthiracdn.com/assets/radheexch-client/banner/main-banner3.webp', 'https://sthiracdn.com/assets/radheexch-client/banner/main-banner4.webp', 'https://sthiracdn.com/assets/radheexch-client/banner/main-banner5.webp'],
            mobileBannerList: ['https://sthiracdn.com/assets/radheexch-client/banner/main-banner2.webp', 'https://sthiracdn.com/assets/radheexch-client/banner/main-banner3.webp', 'https://sthiracdn.com/assets/radheexch-client/banner/main-banner4.webp', 'https://sthiracdn.com/assets/radheexch-client/banner/main-banner5.webp']
        },
        {
            domain: 'thala777.io',
            apiDomain: 'alexisly.com',
            name: 'thala777',
            dName: 'thala777',
            ext: '.io',
            theme: 'blue-body',
            email: '',
            pusher: {
                key: '76d7c55c2b5f8747ffd4',
                cluster: 'eu'
            },
            social: {
                isShow: false,
                whatsapp:'',
                facebook: '',
                instagram: '',
                telegram: '',
            },
            demoLoginWpLink: '',
            themePath: ['assets/css/theme-files/theme-master.css'],
            guestEnable: true,
            ftLivetvData: 'https://getscoredata.com/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
            afLoginRedirectUrl: '/dashboard',
            afterLoginNoticePath: '',
            newHomePage: false,
            isCustomBanner: false,
            demoLogin: true,
            depoWithdraw: true,
            downloadApk: '',
            iframeDomainUrl: 'https://panel.freeplay24.com/',
            signUpActive: true,
            tawkToSrc: '',
            footer: {
                isShow: false,
            },
            desktopBannerList: ['https://static-content-banners.s3.ap-south-1.amazonaws.com/radhe/desktop/bnr1-min-test-img.png', 'https://static-content-banners.s3.ap-south-1.amazonaws.com/radhe/desktop/bnr3-min-test-img.png', 'https://static-content-banners.s3.ap-south-1.amazonaws.com/radhe/desktop/bnr4-min-test-img.png'],
            mobileBannerList: ['https://static-content-banners.s3.ap-south-1.amazonaws.com/radhe/mobile/bnr1-min-test-img.png', 'https://static-content-banners.s3.ap-south-1.amazonaws.com/radhe/mobile/bnr2-min-test-img.png', 'https://static-content-banners.s3.ap-south-1.amazonaws.com/radhe/mobile/bnr3-min-test-img.png', 'https://static-content-banners.s3.ap-south-1.amazonaws.com/radhe/mobile/bnr4-min-test-img.png']
        },
        {
            domain: 'devonline247.com',
            apiDomain: 'devonline247.com',
            name: 'devonline247',
            dName: 'devonline247',
            ext: '.com',
            theme: 'blue-body',
            email: '',
            pusher: {
                key: 'c8bbdb36496c73b41567',
                cluster: 'eu'
            },
            social: {
                isShow: false,
                whatsapp:'',
                facebook: '',
                instagram: '',
                telegram: '',
            },
            demoLoginWpLink: '',
            themePath: ['assets/css/theme-files/theme-blue.css'],
            guestEnable: true,
            ftLivetvData: 'https://getscoredata.com/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
            afLoginRedirectUrl: '/dashboard',
            afterLoginNoticePath: '',
            newHomePage: false,
            isCustomBanner: false,
            demoLogin: true,
            depoWithdraw: true,
            downloadApk: '',
            iframeDomainUrl: 'https://77panel.io/',
            signUpActive: true,
            tawkToSrc: '',
            footer: {
                isShow: true,
            },
            desktopBannerList: ['https://static-content-banners.s3.ap-south-1.amazonaws.com/parker/desktop/bnr1-min.png','https://static-content-banners.s3.ap-south-1.amazonaws.com/parker/desktop/bnr2-min.png','https://static-content-banners.s3.ap-south-1.amazonaws.com/parker/desktop/bnr3-min.png','https://static-content-banners.s3.ap-south-1.amazonaws.com/parker/desktop/bnr4-min.png','https://static-content-banners.s3.ap-south-1.amazonaws.com/parker/desktop/bnr5-min.png'],
            mobileBannerList: ['https://static-content-banners.s3.ap-south-1.amazonaws.com/parker/mobile/bnr1-min.png','https://static-content-banners.s3.ap-south-1.amazonaws.com/parker/mobile/bnr2-min.png','https://static-content-banners.s3.ap-south-1.amazonaws.com/parker/mobile/bnr3-min.png','https://static-content-banners.s3.ap-south-1.amazonaws.com/parker/mobile/bnr4-min.png','https://static-content-banners.s3.ap-south-1.amazonaws.com/parker/mobile/bnr5-min.png']
        },
        {
            domain: 'kgfbook.io',
            apiDomain: 'alexisly.com',
            name: 'kgfbook',
            dName: 'kgfbook',
            ext: '.io',
            theme: 'blue-body',
            email: '',
            pusher: {
                key: '76d7c55c2b5f8747ffd4',
                cluster: 'eu'
            },
            social: {
                isShow: true,
                whatsapp:'https://wa.me/916262529554?text=Hello%20KGF%2C%20Need%20Support',
                facebook: 'https://www.facebook.com/share/1DtSm8brtF/',
                instagram: 'https://www.instagram.com/invites/contact/?utm_source=ig_contact_invite&utm_medium=copy_link&utm_content=be4dd4k',
                telegram: 'https://t.me/kgfhelpsupport',
            },
            demoLoginWpLink: 'https://kgfbetting550-spec.github.io/Kgf-site/',
            themePath: ['assets/css/theme-files/theme-gold.css'],
            guestEnable: true,
            ftLivetvData: 'https://getscoredata.com/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
            afLoginRedirectUrl: '/dashboard',
            afterLoginNoticePath: '',
            newHomePage: false,
            isCustomBanner: false,
            demoLogin: true,
            depoWithdraw: true,
            downloadApk: '',
            iframeDomainUrl: 'https://panel.freeplay24.com/',
            signUpActive: true,
            tawkToSrc: '',
            footer: {
                isShow: true,
            },
            desktopBannerList: ['https://static-content-banners.s3.ap-south-1.amazonaws.com/radhe/desktop/bnr1-min-test-img.png', 'https://static-content-banners.s3.ap-south-1.amazonaws.com/radhe/desktop/bnr3-min-test-img.png', 'https://static-content-banners.s3.ap-south-1.amazonaws.com/radhe/desktop/bnr4-min-test-img.png'],
            mobileBannerList: ['https://static-content-banners.s3.ap-south-1.amazonaws.com/radhe/mobile/bnr1-min-test-img.png', 'https://static-content-banners.s3.ap-south-1.amazonaws.com/radhe/mobile/bnr2-min-test-img.png', 'https://static-content-banners.s3.ap-south-1.amazonaws.com/radhe/mobile/bnr3-min-test-img.png', 'https://static-content-banners.s3.ap-south-1.amazonaws.com/radhe/mobile/bnr4-min-test-img.png']
        },
        {
            domain: 'kgfexchange.io',
            apiDomain: 'alexisly.com',
            name: 'kgfexchange',
            dName: 'kgfexchange',
            ext: '.io',
            theme: 'blue-body',
            email: '',
            pusher: {
                key: '76d7c55c2b5f8747ffd4',
                cluster: 'eu'
            },
            social: {
                isShow: true,
                whatsapp:'https://wa.me/916262529554?text=Hello%20KGF%2C%20Need%20Support',
                facebook: 'https://www.facebook.com/share/1DtSm8brtF/',
                instagram: 'https://www.instagram.com/invites/contact/?utm_source=ig_contact_invite&utm_medium=copy_link&utm_content=be4dd4k',
                telegram: 'https://t.me/kgfhelpsupport',
            },
            demoLoginWpLink: 'https://kgfbetting550-spec.github.io/Kgf-site/',
            themePath: ['assets/css/theme-files/theme-gold.css'],
            guestEnable: true,
            ftLivetvData: 'https://getscoredata.com/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
            afLoginRedirectUrl: '/dashboard',
            afterLoginNoticePath: '',
            newHomePage: false,
            isCustomBanner: false,
            demoLogin: true,
            depoWithdraw: true,
            downloadApk: '',
            iframeDomainUrl: 'https://panel.freeplay24.com/',
            signUpActive: true,
            tawkToSrc: '',
            footer: {
                isShow: true,
            },
            desktopBannerList: ['https://static-content-banners.s3.ap-south-1.amazonaws.com/radhe/desktop/bnr1-min-test-img.png', 'https://static-content-banners.s3.ap-south-1.amazonaws.com/radhe/desktop/bnr3-min-test-img.png', 'https://static-content-banners.s3.ap-south-1.amazonaws.com/radhe/desktop/bnr4-min-test-img.png'],
            mobileBannerList: ['https://static-content-banners.s3.ap-south-1.amazonaws.com/radhe/mobile/bnr1-min-test-img.png', 'https://static-content-banners.s3.ap-south-1.amazonaws.com/radhe/mobile/bnr2-min-test-img.png', 'https://static-content-banners.s3.ap-south-1.amazonaws.com/radhe/mobile/bnr3-min-test-img.png', 'https://static-content-banners.s3.ap-south-1.amazonaws.com/radhe/mobile/bnr4-min-test-img.png']
        },
        {
            domain: 'bossbet247.io',
            apiDomain: 'bossbet247.io',
            name: 'bossbet247',
            dName: 'bossbet247',
            ext: '.io',
            theme: 'blue-body',
            email: '',
            pusher: {
                key: '30d84d922854368d449e',
                cluster: 'eu'
            },
            social: {
                isShow: false,
                whatsapp:'',
                facebook: '',
                instagram: '',
                telegram: '',
            },
            demoLoginWpLink: '',
            themePath: ['assets/css/theme-files/theme-master.css'],
            guestEnable: true,
            ftLivetvData: 'https://getscoredata.com/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
            afLoginRedirectUrl: '/dashboard',
            afterLoginNoticePath: 'https://sthiracdn.com/assets/radheexch-client/popup-new.jpg',
            newHomePage: false,
            isCustomBanner: false,
            demoLogin: true,
            depoWithdraw: true,
            downloadApk: '',
            iframeDomainUrl: 'https://77panel.io/',
            signUpActive: true,
            tawkToSrc: '',
            footer: {
                isShow: false,
            },
            desktopBannerList: ['https://sthiracdn.com/assets/radheexch-client/banner/main-banner2.webp', 'https://sthiracdn.com/assets/radheexch-client/banner/main-banner3.webp', 'https://sthiracdn.com/assets/radheexch-client/banner/main-banner4.webp', 'https://sthiracdn.com/assets/radheexch-client/banner/main-banner5.webp'],
            mobileBannerList: ['https://sthiracdn.com/assets/radheexch-client/banner/main-banner2.webp', 'https://sthiracdn.com/assets/radheexch-client/banner/main-banner3.webp', 'https://sthiracdn.com/assets/radheexch-client/banner/main-banner4.webp', 'https://sthiracdn.com/assets/radheexch-client/banner/main-banner5.webp']
        },
        {
            domain: 'mycircle111.com',
            apiDomain: 'mycircle111.com',
            name: 'mycircle111',
            dName: 'mycircle111',
            ext: '.com',
            theme: 'blue-body',
            email: '',
            pusher: {
                key: '30d84d922854368d449e',
                cluster: 'eu'
            },
            social: {
                isShow: false,
                whatsapp:'',
                facebook: '',
                instagram: '',
                telegram: '',
            },
            demoLoginWpLink: '',
            themePath: ['assets/css/theme-files/theme-master.css'],
            guestEnable: true,
            ftLivetvData: 'https://getscoredata.com/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
            afLoginRedirectUrl: '/dashboard',
            afterLoginNoticePath: '',
            newHomePage: false,
            isCustomBanner: false,
            demoLogin: true,
            depoWithdraw: true,
            downloadApk: '',
            iframeDomainUrl: 'https://77panel.io/',
            signUpActive: true,
            tawkToSrc: '',
            footer: {
                isShow: false,
            },
            desktopBannerList: ['https://sthiracdn.com/assets/radheexch-client/banner/main-banner2.webp', 'https://sthiracdn.com/assets/radheexch-client/banner/main-banner3.webp', 'https://sthiracdn.com/assets/radheexch-client/banner/main-banner4.webp', 'https://sthiracdn.com/assets/radheexch-client/banner/main-banner5.webp'],
            mobileBannerList: ['https://sthiracdn.com/assets/radheexch-client/banner/main-banner2.webp', 'https://sthiracdn.com/assets/radheexch-client/banner/main-banner3.webp', 'https://sthiracdn.com/assets/radheexch-client/banner/main-banner4.webp', 'https://sthiracdn.com/assets/radheexch-client/banner/main-banner5.webp']
        },
        {
            domain: 'jeetexch.live',
            apiDomain: 'alexisly.com',
            name: 'jeetexch',
            dName: 'jeetexch',
            ext: '.live',
            theme: 'blue-body',
            email: '',
            pusher: {
                key: '76d7c55c2b5f8747ffd4',
                cluster: 'eu'
            },
            social: {
                isShow: false,
                whatsapp:'',
                facebook: '',
                instagram: '',
                telegram: '',
            },
            demoLoginWpLink: '',
            themePath: ['assets/css/theme-files/theme-master.css'],
            guestEnable: true,
            ftLivetvData: 'https://getscoredata.com/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
            afLoginRedirectUrl: '/dashboard',
            afterLoginNoticePath: '',
            newHomePage: false,
            isCustomBanner: false,
            demoLogin: true,
            depoWithdraw: false,
            downloadApk: '',
            iframeDomainUrl: '',
            signUpActive: false,
            tawkToSrc: '',
            footer: {
                isShow: true,
            },
            desktopBannerList: ['https://sthiracdn.com/assets/radheexch-client/banner/main-banner2.webp', 'https://sthiracdn.com/assets/radheexch-client/banner/main-banner3.webp', 'https://sthiracdn.com/assets/radheexch-client/banner/main-banner4.webp', 'https://sthiracdn.com/assets/radheexch-client/banner/main-banner5.webp'],
            mobileBannerList: ['https://sthiracdn.com/assets/radheexch-client/banner/main-banner2.webp', 'https://sthiracdn.com/assets/radheexch-client/banner/main-banner3.webp', 'https://sthiracdn.com/assets/radheexch-client/banner/main-banner4.webp', 'https://sthiracdn.com/assets/radheexch-client/banner/main-banner5.webp']
        },
        {
            domain: 'divineexch.online',
            apiDomain: 'divineexch.online',
            name: 'divineexch',
            dName: 'divineexch',
            ext: '.online',
            theme: 'blue-body',
            email: '',
            pusher: {
                key: 'c8bbdb36496c73b41567',
                cluster: 'eu'
            },
            social: {
                isShow: false,
                whatsapp:'',
                facebook: '',
                instagram: '',
                telegram: '',
            },
            demoLoginWpLink: '',
            themePath: ['assets/css/theme-files/theme-master.css'],
            guestEnable: true,
            ftLivetvData: 'https://getscoredata.com/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
            afLoginRedirectUrl: '/dashboard',
            afterLoginNoticePath: '',
            newHomePage: false,
            isCustomBanner: false,
            demoLogin: true,
            depoWithdraw: true,
            downloadApk: '',
            iframeDomainUrl: 'https://77panel.io/',
            signUpActive: true,
            tawkToSrc: '',
            footer: {
                isShow: false,
            },
            desktopBannerList: ['https://sthiracdn.com/assets/radheexch-client/banner/main-banner2.webp', 'https://sthiracdn.com/assets/radheexch-client/banner/main-banner3.webp', 'https://sthiracdn.com/assets/radheexch-client/banner/main-banner4.webp', 'https://sthiracdn.com/assets/radheexch-client/banner/main-banner5.webp'],
            mobileBannerList: ['https://sthiracdn.com/assets/radheexch-client/banner/main-banner2.webp', 'https://sthiracdn.com/assets/radheexch-client/banner/main-banner3.webp', 'https://sthiracdn.com/assets/radheexch-client/banner/main-banner4.webp', 'https://sthiracdn.com/assets/radheexch-client/banner/main-banner5.webp']
        },
        {
            domain: 'genz555.com',
            apiDomain: 'genz555.com',
            name: 'genz555',
            dName: 'genz555',
            ext: '.com',
            theme: 'blue-body',
            email: '',
            pusher: {
                key: '30d84d922854368d449e',
                cluster: 'eu'
            },
            social: {
                isShow: false,
                whatsapp:'',
                facebook: '',
                instagram: '',
                telegram: '',
            },
            demoLoginWpLink: '',
            themePath: ['assets/css/theme-files/theme-master.css'],
            guestEnable: true,
            ftLivetvData: 'https://getscoredata.com/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
            afLoginRedirectUrl: '/dashboard',
            afterLoginNoticePath: '',
            newHomePage: false,
            isCustomBanner: false,
            demoLogin: true,
            depoWithdraw: true,
            downloadApk: '',
            iframeDomainUrl: 'https://77panel.io/',
            signUpActive: true,
            tawkToSrc: '',
            footer: {
                isShow: false,
            },
            desktopBannerList: ['https://sthiracdn.com/assets/radheexch-client/banner/main-banner2.webp', 'https://sthiracdn.com/assets/radheexch-client/banner/main-banner3.webp', 'https://sthiracdn.com/assets/radheexch-client/banner/main-banner4.webp', 'https://sthiracdn.com/assets/radheexch-client/banner/main-banner5.webp'],
            mobileBannerList: ['https://sthiracdn.com/assets/radheexch-client/banner/main-banner2.webp', 'https://sthiracdn.com/assets/radheexch-client/banner/main-banner3.webp', 'https://sthiracdn.com/assets/radheexch-client/banner/main-banner4.webp', 'https://sthiracdn.com/assets/radheexch-client/banner/main-banner5.webp']
        },
        {
            domain: 'genz555.com',
            apiDomain: 'genz555.com',
            name: 'playgenz555nwin247',
            dName: 'genz555',
            ext: '.com',
            theme: 'blue-body',
            email: '',
            pusher: {
                key: '30d84d922854368d449e',
                cluster: 'eu'
            },
            social: {
                isShow: false,
                whatsapp:'',
                facebook: '',
                instagram: '',
                telegram: '',
            },
            demoLoginWpLink: '',
            themePath: ['assets/css/theme-files/theme-master.css'],
            guestEnable: true,
            ftLivetvData: 'https://getscoredata.com/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
            afLoginRedirectUrl: '/dashboard',
            afterLoginNoticePath: '',
            newHomePage: false,
            isCustomBanner: false,
            demoLogin: true,
            depoWithdraw: true,
            downloadApk: '',
            iframeDomainUrl: 'https://77panel.io/',
            signUpActive: true,
            tawkToSrc: '',
            footer: {
                isShow: false,
            },
            desktopBannerList: ['https://sthiracdn.com/assets/radheexch-client/banner/main-banner2.webp', 'https://sthiracdn.com/assets/radheexch-client/banner/main-banner3.webp', 'https://sthiracdn.com/assets/radheexch-client/banner/main-banner4.webp', 'https://sthiracdn.com/assets/radheexch-client/banner/main-banner5.webp'],
            mobileBannerList: ['https://sthiracdn.com/assets/radheexch-client/banner/main-banner2.webp', 'https://sthiracdn.com/assets/radheexch-client/banner/main-banner3.webp', 'https://sthiracdn.com/assets/radheexch-client/banner/main-banner4.webp', 'https://sthiracdn.com/assets/radheexch-client/banner/main-banner5.webp']
        },
        {
            domain: 'cricketexch.vip',
            apiDomain: 'cricketexch.vip',
            name: 'cricketexch',
            dName: 'cricketexch',
            ext: '.vip',
            theme: 'blue-body',
            email: '',
            pusher: {
                key: '30d84d922854368d449e',
                cluster: 'eu'
            },
            social: {
                isShow: false,
                whatsapp:'',
                facebook: '',
                instagram: '',
                telegram: '',
            },
            demoLoginWpLink: '',
            themePath: ['assets/css/theme-files/theme-yellow.css'],
            guestEnable: true,
            ftLivetvData: 'https://getscoredata.com/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
            afLoginRedirectUrl: '/dashboard',
            afterLoginNoticePath: 'https://sthiracdn.com/assets/popup/popup-casino-fifa2026-new2.webp',
            newHomePage: false,
            isCustomBanner: false,
            demoLogin: true,
            depoWithdraw: true,
            downloadApk: '',
            iframeDomainUrl: 'https://77panel.io/',
            signUpActive: true,
            tawkToSrc: '',
            footer: {
                isShow: false,
            },
            desktopBannerList: ['https://sthiracdn.com/assets/radheexch-client/banner/main-banner2.webp', 'https://sthiracdn.com/assets/radheexch-client/banner/main-banner3.webp', 'https://sthiracdn.com/assets/radheexch-client/banner/main-banner4.webp', 'https://sthiracdn.com/assets/radheexch-client/banner/main-banner5.webp'],
            mobileBannerList: ['https://sthiracdn.com/assets/radheexch-client/banner/main-banner2.webp', 'https://sthiracdn.com/assets/radheexch-client/banner/main-banner3.webp', 'https://sthiracdn.com/assets/radheexch-client/banner/main-banner4.webp', 'https://sthiracdn.com/assets/radheexch-client/banner/main-banner5.webp']
        }
    ]
};
